<template>
  <div class="popup-back">
    <!-- 포스터 4개 이하 -->
    <section class="popup pop-intro">
      <h1 class="popup-title" tabindex="1">{{ popupTitle }}</h1>
      <div class="popup-button-close">
        <a href="#" @click.prevent="setPinCodePage(false)">
          <img src="../../assets/images/wavvezone/icon-close.png" alt="icon-close" />
        </a>
      </div>
      <div class="pop-con">
        <strong v-if="isAdult">성인인증번호를 입력하세요.</strong>
        <strong v-else>웨이브온<br />접속번호를 입력하세요.</strong>
        <p>모르실 경우, 카운터에 문의하세요</p>
        <ul>
          <li>
            <em :class="getPinCodeCss(pincode[0])">dotted</em>
            <input id="pincode0" type="text" v-model.number="pincode[0]" @keyup="changePincode(0)" @keyup.delete="deletePincode(0)" maxlength="1" />
          </li>
          <li>
            <em :class="getPinCodeCss(pincode[1])">dotted</em>
            <input id="pincode1" type="text" v-model.number="pincode[1]" @keyup="changePincode(1)" @keyup.delete="deletePincode(1)" maxlength="1" />
          </li>
          <li>
            <em :class="getPinCodeCss(pincode[2])">dotted</em>
            <input id="pincode2" type="text" v-model.number="pincode[2]" @keyup="changePincode(2)" @keyup.delete="deletePincode(2)" maxlength="1" />
          </li>
          <li>
            <em :class="getPinCodeCss(pincode[3])">dotted</em>
            <input id="pincode3" type="text" v-model.number="pincode[3]" @keyup="changePincode(3)" @keyup.delete="deletePincode(3)" @keydown.enter="checkAdult()" maxlength="1" />
          </li>
        </ul>
        <div class="pop-btn">
          <a @click.prevent="setPinCodePage(false)" href="#" class="btn-cancel">취소</a>
          <a v-if="isAdult" @click.prevent="checkAdult()" href="#" class="btn-confirm">확인</a>
          <a v-else @click.prevent="loginPooqzone()" href="#" class="btn-confirm">확인</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { pooqzoneLoginProc } from '@/common/utils/login'
import constant from '@/common/resources/constant'
import cookie from '@/common/utils/cookie'
import { PATH_NAME_HOME } from '@/common/resources/router.const'

export default {
  props: {
    isAdult: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pincode: ['', '', '', '']
    }
  },
  computed: {
    popupTitle () {
      return this.isAdult ? '성인인증번호 입력 팝업' : '웨이브온 접속번호 입력 팝업'
    }
  },
  methods: {
    // 핀코드 입력에 따른 CSS
    getPinCodeCss (target) {
      return '' + target ? 'on' : ''
    },
    // 핀코드 확인 여부
    loginPooqzone () {
      if ('' + this.pincode[0] && '' + this.pincode[1] && '' + this.pincode[2] && '' +
        this.pincode[3]) {
        let pincode = '' + this.pincode[0] + this.pincode[1] + this.pincode[2] + this.pincode[3]
        pooqzoneLoginProc({ pincode }).then(() => {
          this.$router.push({ name: PATH_NAME_HOME })
        }).catch((error) => {
          if (error.response.data.resultcode === '100') {
            alert(error.response.data.resultmessage)
            this.goPooqService()
          } else if (error.response.data.resultcode === '550') {
            alert(error.response.data.resultmessage)
            this.resetPincode()
          }
        })
      } else {
        alert('웨이브온 접속번호를 입력해 주세요.')
      }
    },
    checkAdult () {
      if ('' + this.pincode[0] && '' + this.pincode[1] && '' + this.pincode[2] &&
        '' + this.pincode[3]) {
        let pincode = '' + this.pincode[0] + this.pincode[1] + this.pincode[2] + this.pincode[3]
        this.$events.$emit('checkAdult', pincode)
      } else {
        alert('성인인증번호가 올바르지 않습니다. 다시 입력해 주세요.')
        this.resetPincode()
      }
    },
    // 기존 Pooq 서비스로 보기
    goPooqService () {
      cookie.removeItems({ keyList: ['pzInfo', 'pz'] })
      cookie.setItem('pz', JSON.stringify({ isPooqzone: false }), false, constant.URL_COOKIE_DOMAIN, '/')
      this.$router.push({ name: PATH_NAME_HOME })
    },
    changePincode (id) {
      let element = document.getElementById('pincode' + id)
      let nextElement = document.getElementById('pincode' + (id + 1))
      if (element && nextElement && '' + this.pincode[id]) {
        nextElement.focus()
      }
    },
    deletePincode (id) {
      let element = document.getElementById('pincode' + id)
      let prevElement = document.getElementById('pincode' + (id - 1))
      if (element && prevElement && !('' + this.pincode[id])) {
        prevElement.focus()
      }
    },
    setPinCodePage (isView) {
      this.$events.$emit('setPinCodePage', isView)
    },
    // 핀코드 초기화 후 첫번째 input 포커스
    resetPincode () {
      this.pincode[0] = ''
      this.pincode[1] = ''
      this.pincode[2] = ''
      this.pincode[3] = ''
      let element = document.getElementById('pincode0')
      if (element) {
        element.focus()
      }
    }
  },
  mounted () {
    let element = document.getElementById('pincode0')
    if (element) {
      element.focus()
    }
  }
}
</script>
